var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.donwloadUrl && !_vm.isChannel)?_c('a',{class:_vm.$style.download,attrs:{"href":_vm.donwloadUrl,"target":"_blank"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }